// MSALContext.js
import React, { createContext, useEffect, useState } from "react";
import pca from "./Auth/msalConfig";

export const MSALContext = createContext(null);

export const MSALProvider = ({ children }) => {
	const [msalInstance, setMsalInstance] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const initializeMsal = async () => {
			try {
				await pca.initialize();
				setMsalInstance(pca);
			} catch (error) {
				console.error("MSAL initialization error:", error);
			} finally {
				setLoading(false);
			}
		};

		initializeMsal();
	}, []);

	if (loading) {
		return <div>Loading...</div>; // Show a loading screen or spinner while initializing
	}

	return (
		<MSALContext.Provider value={{ msalInstance }}>
			{children}
		</MSALContext.Provider>
	);
};
